import React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'
import { Box, Typography } from '@mui/material'

const DepartmentChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <Typography color="text.secondary">No data available</Typography>
      </Box>
    )
  }

  const chartData = data.map(dept => ({
    name: dept.departmentName || dept.name || 'Unknown',
    pending: dept.pendingCount || dept.pending || 0,
    completed: dept.completedCount || dept.completed || 0
  }))

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="pending" fill="#ff9800" name="Pending" />
        <Bar dataKey="completed" fill="#4caf50" name="Completed" />
      </BarChart>
    </ResponsiveContainer>
  )
}

export default DepartmentChart